import * as React from "react";
import {
    Fragment,
} from "react";

import { Grid } from "@mui/material";
import quoteStyles from "./quoteStyles";

const Quotes = () => {
    const {classes } = quoteStyles()
    const {
        mainblock,
        heading,
        iframeCtn
    } = classes;

    return (
        <Fragment>
            <Grid container direction="column" className={mainblock}>
                <Grid className={heading} item sx={{width:"100%"}}>
                    Quotes
                </Grid>
                <Grid item className={iframeCtn}>
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://docs.google.com/spreadsheets/d/1JuCANXhLvn5LfTuc2cMmUKtBskMN-aW4l_3Eg4uoz5A/edit?usp=sharing/pubhtml?/edit?usp=sharing?&amp;gid=1488210894&amp;single=true&amp;widget=true&amp;headers=true&amp;"></iframe>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default Quotes;